import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";

import GuideLine from "../../../../components/guide-line";
import MainButton from "../../../../components/main-button";
import SelectBox from "../../../../components/select-box/select-box";
import { Calendar, Label } from "../../../../components/form";
import { SaludPymesMediatorContainer } from "./salud-pymes-mediator-style";
import { images } from "../../../../assets";

import { withCoverages } from "../../../../context/mixin/with-coverages";
import { withGeneral } from "../../../../context/mixin/with-general";
import { withPolicy } from "../../../../context/mixin/with-policy";
import { STORAGE_KEY } from "../../../../constants/health";

import MediatorServices from "../../../../services/MediatorServices";
import { getRelatedMediatorsCodes } from "../../../../utils/mediatorCode";
import { isValidDate } from "../../../../utils/time";
import { deepGet } from "../../../../utils/utility";
import { MediatorProps, MediatorState } from "./salud-pymes-mediator-types";

class PymesMediator extends React.Component<MediatorProps, MediatorState> {
  constructor(props: MediatorProps) {
    super(props);
    let pymesSimulationData;
    if (localStorage.getItem(STORAGE_KEY.sKey)) {
      pymesSimulationData = JSON.parse(String(localStorage.getItem(STORAGE_KEY.sKey)));
    }

    this.state = {
      mediatorValue: `${props.user.name} ${props.user.lastname1} ${props.user.lastname2}`,
      mediatorData: {
        code: "",
        name: "",
        startDate: pymesSimulationData
          ? pymesSimulationData.mediatorData.startDate
          : moment().format("DD/MM/YYYY").toLocaleString(),
      },
      pymesSimulationData: pymesSimulationData,
      nextDisabled: false,
      relatedMediatorCodes: getRelatedMediatorsCodes(this.props.mediator),
      mediatorCodeSelected: props.selectedMediatorCode
        ? props.selectedMediatorCode
        : props.mediator.mediatorCode,
    };
  }

  componentDidMount = () => {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);
  };

  async handleSelectMediatorChange(value: string) {
    this.props.policy.setMediatorSelectedCode && this.props.policy.setMediatorSelectedCode(value);
    this.setState({ mediatorCodeSelected: value });
    const w: any = window;
    const mediator = {
      setLoading: w.setLoader,
      loader: true,
      mediatorCode: value,
    };
    const mediatorName = await MediatorServices.getMediatorInfo(mediator);
    this.setState((prev) => ({
      mediatorData: { ...prev.mediatorData, name: value, code: value },
      mediatorValue: mediatorName.mediatorName,
    }));
  }

  isValidData = (): boolean => {
    const { mediatorData } = this.state;
    if (!mediatorData.startDate) return false;
    if (!isValidDate(mediatorData.startDate)) return false;
    return true;
  };

  toValidate = () => {
    const { mediatorValue, pymesSimulationData, mediatorData } = this.state;
    const isValidData = this.isValidData();
    if (!isValidData) return;

    mediatorData.name = mediatorValue;

    if (pymesSimulationData) {
      const newPymesSimulationData = {
        ...pymesSimulationData,
        mediatorData,
      };
      localStorage.setItem(STORAGE_KEY.sKey, JSON.stringify({ ...newPymesSimulationData }));
    } else {
      localStorage.setItem(
        STORAGE_KEY.sKey,
        JSON.stringify({
          mediatorData: this.state.mediatorData,
        })
      );
    }

    const { history } = this.props;
    if (mediatorData.code) history.push("/simulacion/nueva/salud-pymes/asegurados");
  };

  changeDateValue(value: string, error?: boolean, errorCode?: string) {
    this.setState((prev) => ({
      mediatorData: { ...prev.mediatorData, startDate: value },
      nextDisabled: !!errorCode,
    }));
  }

  render() {
    let { mediatorData, nextDisabled, relatedMediatorCodes, mediatorCodeSelected } =
      this.state;
    const startDateMax = deepGet(this.props, "policy.product.products_startDateMax", 90) || 90;
    const startDateMin = deepGet(this.props, "policy.product.products_startDateMin", 0) || 0;

    return (
      <SaludPymesMediatorContainer>
        <div className="data-flow-status">
          <div className="data-flow-status-title">
            <h2>DATOS DEL SEGURO</h2>
          </div>
          <div className="data-flow-status-guide">
            <GuideLine steps={[0, 0, 0, 0]} currentStep={1} />
          </div>
        </div>

        <div className="content-wrapper bottomMargin20">
          <div className="personal-data-wrapper">
            <div className="data-title">
              <h5>DATOS SIMULACION</h5>
            </div>

            <div className="colSin-100 topMargin20">
              <div className="colSin-50 rightPadding20">
                <div className="inputBox">
                  <SelectBox
                    isMediator={true}
                    optionsText={relatedMediatorCodes}
                    optionKey={"value"}
                    optionValue={"label"}
                    defaultValue={mediatorCodeSelected}
                    onChange={(value: string) => this.handleSelectMediatorChange(value)}
                    propValue={mediatorCodeSelected}
                    required
                  />
                  <label>Mediador</label>
                </div>
              </div>

              <div className="colSin-50 rightPadding20">
                <div className="inputBox">
                  <Label className="required">Fecha efecto</Label>
                  <Calendar
                    value={mediatorData.startDate}
                    maxDate={moment().add(startDateMax, "days").toLocaleString()}
                    minDate={moment().subtract(startDateMin, "days").toLocaleString()}
                    onChange={(value: string, error?: boolean, errorCode?: string) => {
                      this.changeDateValue(value, error, errorCode);
                    }}
                    errorText={""}
                    removeClearIcon
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="colSin-100">
          <div className="personal-data-buttons">
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                icon={true}
                type={"white"}
                iconImg={images.IconArrowLeftBlue}
                text="Atrás"
                onClick={() => this.props.history.push("/simulacion/nueva")}
              />
            </div>
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                text="Siguiente"
                disabled={nextDisabled || !this.isValidData()}
                onClick={() => this.toValidate()}
              />
            </div>
          </div>
        </div>
      </SaludPymesMediatorContainer>
    );
  }
}

export default withGeneral(withCoverages(withPolicy(withRouter(PymesMediator))));
